import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openClosePopUp } from '../../layout2.0/action/homeAction'
import {withTranslation} from 'react-i18next'
class PopUp extends Component {


    cancelCheckOut = () => {
        this.props.openClosePopUp(false, null);
    }

    render() {
        const {t} = this.props
        return (
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content">
                            {this.props.popUpMessage ? this.props.popUpMessage : ""}
                        </div>
                        <div class="overlay-controls">
                            <button onClick={this.cancelCheckOut} class="button secondary">{t('check_in.cancel')}</button>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        popUpMessage: state.store2.popUpMessage
    }
}

export default connect(
    mapStateToProps,
    {
        openClosePopUp
    }
)(withTranslation('translations')(PopUp));